import type { Modifier } from '@dnd-kit/core';

export function getActivatorCoordinates(event: Event) {
  if ('clientX' in event && typeof (event as PointerEvent).clientX === 'number') {
    const pointerEvent = event as PointerEvent;
    return { x: pointerEvent.clientX, y: pointerEvent.clientY };
  }

  if ('touches' in event) {
    const touch = (event as TouchEvent).touches[0] ?? (event as TouchEvent).changedTouches[0];
    if (touch) return { x: touch.clientX, y: touch.clientY };
  }

  return null;
}

/** Keeps the drag preview centered under the pointer / finger. */
export const snapCenterToCursor: Modifier = ({ activatorEvent, draggingNodeRect, transform }) => {
  if (!draggingNodeRect || !activatorEvent) return transform;

  const coordinates = getActivatorCoordinates(activatorEvent);
  if (!coordinates) return transform;

  return {
    ...transform,
    x: transform.x + coordinates.x - draggingNodeRect.left - draggingNodeRect.width / 2,
    y: transform.y + coordinates.y - draggingNodeRect.top - draggingNodeRect.height / 2,
  };
};
